import SectionHub from '@/components/docs/SectionHub';

export default function Docs01MarketDataCryptoHub() {
  return <SectionHub sectionPath="01-market-data/crypto" />;
}
